import React, { useMemo } from 'react';
interface CurrencyConfig {
  symbol: string;
  multiplier: number;
  position: 'before' | 'after';
  decimals: number;
  separator: string;
}
const CURRENCY_MAP: Record<string, CurrencyConfig> = {
  USD: {
    symbol: '$',
    multiplier: 1,
    position: 'before',
    decimals: 2,
    separator: '.'
  },
  BRL: {
    symbol: 'R$',
    multiplier: 5.2,
    position: 'before',
    decimals: 2,
    separator: ','
  },
  EUR: {
    symbol: '€',
    multiplier: 0.92,
    position: 'after',
    decimals: 2,
    separator: ','
  },
  GBP: {
    symbol: '£',
    multiplier: 0.79,
    position: 'before',
    decimals: 2,
    separator: '.'
  },
  MXN: {
    symbol: '$',
    multiplier: 17.2,
    position: 'before',
    decimals: 2,
    separator: '.'
  },
  ARS: {
    symbol: '$',
    multiplier: 870,
    position: 'before',
    decimals: 0,
    separator: '.'
  },
  COP: {
    symbol: '$',
    multiplier: 3950,
    position: 'before',
    decimals: 0,
    separator: '.'
  },
  CLP: {
    symbol: '$',
    multiplier: 940,
    position: 'before',
    decimals: 0,
    separator: '.'
  }
};
function detectCurrency(): string {
  if (typeof navigator === 'undefined') return 'USD';
  const lang = navigator.language || 'en-US';
  const lower = lang.toLowerCase();
  if (lower.startsWith('pt')) return 'BRL';
  if (lower === 'es-mx') return 'MXN';
  if (lower === 'es-ar') return 'ARS';
  if (lower === 'es-co') return 'COP';
  if (lower === 'es-cl') return 'CLP';
  if (lower.startsWith('es')) return 'USD';
  if (lower.startsWith('en-gb')) return 'GBP';
  if (lower.startsWith('en')) return 'USD';
  if (lower.startsWith('fr') || lower.startsWith('de') || lower.startsWith('it') || lower.startsWith('nl')) return 'EUR';
  return 'USD';
}
function formatPrice(amount: number, config: CurrencyConfig): string {
  const converted = Math.round(amount * config.multiplier * 100) / 100;
  const formatted = config.decimals === 0 ? Math.round(converted).toLocaleString() : converted.toFixed(config.decimals).replace('.', config.separator);
  return config.position === 'before' ? `${config.symbol}${formatted}` : `${formatted}${config.symbol}`;
}
interface PriceDisplayProps {
  basePrice: number;
  originalPrice?: number;
  showOriginal?: boolean;
  className?: string;
  originalClassName?: string;
  priceClassName?: string;
}
export function PriceDisplay({
  basePrice,
  originalPrice,
  showOriginal = false,
  className = '',
  originalClassName = 'text-gray-500 line-through text-2xl',
  priceClassName = 'text-5xl md:text-6xl font-black text-gold'
}: PriceDisplayProps) {
  const currency = useMemo(() => detectCurrency(), []);
  const config = CURRENCY_MAP[currency] || CURRENCY_MAP.USD;
  return <div className={`flex items-center justify-center gap-4 ${className}`} data-id="element-83">
      {showOriginal && originalPrice && <span className={originalClassName} data-id="element-84">
          {formatPrice(originalPrice, config)}
        </span>}
      <span className={priceClassName} data-id="element-85">{formatPrice(basePrice, config)}</span>
    </div>;
}